// Vendors
import React from 'react'
import { useParams } from 'react-router'

// Components
import { CompanyLogisticsFormShow } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

import { PageMetaSetting } from './meta'

export const PageCompanyLogisticShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */

  return (
    <LayoutLoggedPageList title={title}>
      <CompanyLogisticsFormShow endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
